import { Rechnungsperson } from "./rechnungsperson"

export class Rechnungssteller {
    rechnungssteller = new Rechnungsperson(false)
    // BT-32
    steuernummer = ""
    // BT-32-1
    steuernummerSchema = ""
    // BT-29
    verkauferinformation = ""
    // BT-33
    rechtlicheInformationen = ""

    toJSON() {
        return {
            rechnungssteller: this.rechnungssteller,
            steuernummer: this.steuernummer,
            steuernummerSchema: this.steuernummerSchema.trim().length > 0 ? this.steuernummerSchema : null,
            verkauferinformation: this.verkauferinformation,
            rechtlicheInformationen: this.rechtlicheInformationen,
        }
    }
}
